export const inr = (n) => {
  if (isNaN(n) || n === null) return "₹0";
  const x = Math.round(n);
  return "₹" + x.toLocaleString("en-IN");
};

export const inrShort = (n) => {
  if (isNaN(n)) return "₹0";
  if (n >= 1e7) return "₹" + (n / 1e7).toFixed(2) + " Cr";
  if (n >= 1e5) return "₹" + (n / 1e5).toFixed(2) + " L";
  return inr(n);
};

// EMI = P r (1+r)^n / ((1+r)^n - 1)
export const calcEmi = (principal, annualRate, years) => {
  const r = annualRate / 12 / 100;
  const n = years * 12;
  if (r === 0) return principal / n;
  const emi = (principal * r * Math.pow(1 + r, n)) / (Math.pow(1 + r, n) - 1);
  return emi;
};

export const CYAN = "#141414";
export const GREY = "#C9C5BD";
